import { Component, Host, h, Prop, Event, EventEmitter, Listen, Element } from '@stencil/core';

import { TealiumClickOutEvent } from '../../../utils/tealium/TealiumClickOutEvent';
import { TealiumShareEvent } from '../../../utils/tealium/TealiumShareEvent';

import { createCSSVariablesForFontsizes } from '../../../utils/utils';

@Component({
  tag: 'lilu-link',
  styleUrl: 'lilu-link.scss',
  shadow: true,
})
export class LiluLink {
  @Prop() link: string;
  @Prop() target = '_self';
  @Prop() appearance = '';
  @Prop() type = '';
  @Prop() icon?: string;
  @Prop() class?: string;
  @Prop() color = 'dark';
  @Prop() colorcode?: string;
  @Prop() font?: string = 'semibold';
  @Prop() size = 'size-16 lg-size-18';
  @Prop() alignment = '';

  @Element() element: HTMLElement;

  isLinkExternal: boolean;

  @Event() mouseoverLiluLink: EventEmitter<object>;

  componentWillLoad() {
    this.isLinkExternal = TealiumClickOutEvent.isLinkExternal(this.link);
  }

  componentDidLoad() {
    createCSSVariablesForFontsizes(this.element, this.size);
  }

  mouseoverLiluLinkHandler(evt: object) {
    this.mouseoverLiluLink.emit(evt);
  }

  @Listen('mouseover')
  handleEvent(e) {
    this.mouseoverLiluLinkHandler(e);
  }

  renderTextColor = () => {
    return { color: this.colorcode };
  };

  /**
   * Links used to support only bright and dark color variants.
   * Now all livique colors are supported, so due to compatility reason we need to map bright and dark variants to our livique color
   */
  mapToIconColor() {
    if (this.color === 'bright') {
      return 'white';
    } else if (this.color === 'dark') {
      return 'nero';
    }
    return this.color;
  }

  trackTealiumClickEvent() {
    if (this.isLinkExternal) {
      if (this.element.getAttribute('slot') === 'social') {
        new TealiumShareEvent(this.link).executeLink();
      } else {
        new TealiumClickOutEvent(this.link).executeLink();
      }
    }
  }

  render() {
    const isInline = (this.appearance || '').split(' ').indexOf('inline') !== -1;

    const hostClasses = [this.size, isInline ? 'inline' : ''].join(' ');

    return (
      <Host part={`${this.size}`} class={`${this.type}`}>
        <div class={`${this.alignment} ${hostClasses} ${this.type}`}>
          <div class={`link ${this.class}`}>
            <a href={this.link ? `${this.link}` : undefined} target={`${this.target}`} onClick={this.isLinkExternal ? _e => this.trackTealiumClickEvent() : undefined}>
              {this.icon && (
                <span class="icon">
                  <lilu-icon color={`${this.mapToIconColor()}`} type={`${this.icon}`}></lilu-icon>
                </span>
              )}
              <span part="span" class={`text ${this.appearance} ${this.color} ${this.font} size`} style={this.colorcode ? this.renderTextColor() : null}>
                <slot></slot>
              </span>
            </a>
          </div>
        </div>
      </Host>
    );
  }
}
